import "./css/site-in-maintenance.css";

const SiteInMaintenance = ({ expectedCompletionDateOfMaintenance, dateSup }) => {
  // array of date, month and year
  const date = expectedCompletionDateOfMaintenance.split(" ");

  return (
    <div className="sim-container">
      <h2 className="sim-title">The site is under maintenance.</h2>

      <p className="sim-message">
        I apologize for any inconvenience, but the website is currently undergoing maintenance.<br />

        The estimated completion date of maintenance is {date[0]}<sup>{dateSup}</sup> {date[1]} {date[2]}.<br />

        I appreciate your patience and understanding as I work to enhance the website.<br />
      </p>

      <p className="sim-closing-statement">
        Sincerely,<br />
        DSolve
      </p>

    </div>
  );
}

export default SiteInMaintenance;